import { gql } from '@apollo/client';

export const UPDATE_REPORTS = gql`
  mutation UpdateReport($id: ID!, $attributes: ReportAttributes!) {
    updateReport(id: $id, attributes: $attributes) {
      report {
        name
        id
        reportData
        shareCode
        shareEnabled
        sharePassword
        company {
          id
        }
      }
    }
  }
`;

export const GET_REPORT_BY_ID = gql`
  query Report($id: ID!) {
    report (id: $id){
      name
      id
      reportData
      shareCode
      shareEnabled
      sharePassword
      company {
        id
      }
    }
  }
`;

export const GET_REPORT_BY_PROJECT_ID = gql`
  query Reports($projectId: ID!) {
    reports(projectId: $projectId) {
      name
      id
      reportData
      shareCode
      shareEnabled
      sharePassword
      testSessionNotes {
        id
        videoUrl
      }
      highlightReels {
        id
        videoUrl
      }
      company {
        id
      }
    }
  }
`;

export const GET_COMPANY_MEMBERS = gql`
  query CompanyMembers($companyId: ID!) {
    companyMembers(companyId: $companyId, hidden: false) {
      id
      user{
        id
        email
        profile {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
